/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { ProductItem } from "../../../shared/services/interface";
import { getProductsFromIndexedDB, saveProductsToIndexedDB } from "src/shared/utils/indexDB/indexedDB";
import { getProduct } from "src/shared/services/services";
import { errorHandling } from "src/shared/utils/errorHandling";
import { useUser } from "../components/UserContext";
import { closeLoading, notifyLoading, notifySuccess } from "src/assets/toastService";

const useProductsIndexDB = (deleted?: boolean, page?: number, limit?: number, sortField?: string, order?: string) => {
  const [product, setProduct] = useState<ProductItem[]>([]);
  const [loadingPro, setLoading] = useState<boolean>(true);
  const { user } = useUser();

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const products = await getProductsFromIndexedDB();

      if (products?.length && user && user.organization_id) {
        const filterByOrg = products.filter((p: any) => p.organization_id === user?.organization_id);
        const formattedProducts = filterByOrg.map((p: any) => ({
          ...p,
          _id: { $oid: p._id },
        }));
        productData(formattedProducts);
      } else {
        productSync();
      }
    } catch (error) {
      console.error("IndexedDB Load Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const productData = (avabileProduct: ProductItem[] | []) => {
    if (avabileProduct.length) {
      setProduct(avabileProduct);
    } else {
      productSync();
    }
  };

  const productSync = () => {
    notifyLoading("Loading Products...");
    getProduct(deleted, page, limit, undefined, undefined, sortField, order)
      .then((res) => {
        saveProductsToIndexedDB(res.data.result);
        setProduct(res.data.result);
        closeLoading();
        notifySuccess("Products Updated Successfully");
      })
      .catch((err) => {
        closeLoading();
        errorHandling(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    product,
    loadingPro,
    productSync,
  };
};

export default useProductsIndexDB;
